import {AxiosError, AxiosResponse} from "axios";
import {Axios} from "../../../axiosHelper";
import {ResponseBase} from "../../data";
import {AddParamRequest, ParamListResponse} from "../../data/deviceParam";
import {deviceParamsActions} from "../../slice/efe/deviceParamSlice";

export const getDeviceParamsList = (systemId: string): any => {
  return async (dispatch: any) => {
    dispatch(deviceParamsActions.setLoading(true));

    Axios.get(`/efe/device-param/list/${systemId}`)
      .then((res: AxiosResponse<ParamListResponse>) => {
        dispatch(deviceParamsActions.setDeviceParamList(res.data.commands));
      })
      .catch((err: AxiosError) => {
        if (err.response) {
          if (err.response.status === 400) {
            const resp: any = err.response.data;
            dispatch(deviceParamsActions.setError(resp));
          }
        }
      });
  };
};

export const addNewDeviceParam = (request: AddParamRequest): any => {
  return async (dispatch: any) => {
    dispatch(deviceParamsActions.setLoading(true));

    Axios.post("/efe/device-param/new", request, {
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then((res: AxiosResponse<ResponseBase>) => {
        dispatch(deviceParamsActions.setResponse(res.data));
      })
      .catch((err: AxiosError) => {
        if (err.response) {
          if (err.response.status === 400) {
            const resp: any = err.response.data;
            dispatch(deviceParamsActions.setError(resp));
          }
        }
      });
  };
};

export const clearDeviceParamResponse = (): any => {
  return async (dispatch: any) => {
    dispatch(deviceParamsActions.setResponse(null));
  };
};

export const clearDeviceParamError = (): any => {
  return async (dispatch: any) => {
    dispatch(deviceParamsActions.setError(null));
  };
};
